/**
 * @name: request
 * @author: Chuwen
 * @date: 2021-04-15 16:38
 * @description：request
 * @update: 2021-04-15 16:38
 */

import axios from "axios";
import md5 from "md5";
import { isShopifyEmbedded, getSessionToken } from "@shopify/app-bridge-utils";
import createApp from "@shopify/app-bridge";
import store from "@/store";
import router from "@/router";
import utilsIndex from "@/utils";
import { getToken, sessionRead } from "@/utils/util";
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";

NProgress.configure({
	easing: "ease", // 动画方式
	speed: 500, // 递增进度条的速度
	showSpinner: true, // 是否显示加载ico
	trickleSpeed: 200, // 自动递增间隔
	minimum: 0.3, // 初始化时的最小百分比
});

const moment = require("moment");

//接口地址
const URL = process.env.VUE_APP_API_URL;
console.log(URL);

//验证用户的数据（假数据）
//TODO：后面需要改为自己的逻辑
const client = axios.create({
	baseURL: URL,
	//不携带 Cookie，这样的话 Access-Control-Allow-Origin 就允许为 *
	//参考链接：https://nowtime.cc/nginx/1360.html
	//        https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Headers/Access-Control-Allow-Credentials
	withCredentials: false,
	headers: {
		"Content-Type": "application/json",
	},
});

const addBaseParams = (data = {}) => {
	let params = Object.assign({}, data);
	// 请求时间
	params.timestamp = moment().format();
	//获取盐
	const saltToken = utilsIndex.getApiKey();

	let dataKey = Object.keys(params);
	let md5Str = "";
	dataKey.sort();
	dataKey.forEach(item => {
		md5Str = md5Str + item;
		for (let name in params) {
			if (name === item) {
				md5Str = md5Str + params[name];
			}
		}
	});

	md5Str = saltToken + md5Str + saltToken;
	params.sign = md5(md5Str);

	return params;
};
//对请求前的拦截器
client.interceptors.request.use(
	config => {
		checkLoading(1);
		config.data = addBaseParams(config.data);
		if (config.data.no_auth_header) {
			return config;
		}
		if (isShopifyEmbedded()) {
			if (store.state.shopifyAppObj === null && sessionRead("host")) {
				var shopifyApp = createApp({
					apiKey: process.env.VUE_APP_API_KEY,
					host: sessionRead("host"),
				});
				store.commit("setShopifyAppObj", shopifyApp);
			}
			if (store.state.shopifyAppObj === null) {
				return config;
			}
			return getSessionToken(store.state.shopifyAppObj).then(token => {
				// Append your request headers with an authenticated token
				config.headers.common["Authorization"] = `bearer ${token}`;
				return config;
			});
		} else {
			let token = getToken();
			if (token) {
				config.headers.common["Authorization"] = "bearer " + token;
			}
			return config;
		}
	},
	error => {
		return Promise.reject(error);
	}
);

//对响应的拦截器
client.interceptors.response.use(
	res => {
		//TODO 隐藏加载框
		checkLoading(2);
		// token失败 或 签名失败
		if (res.data.status === "fail") {
			switch (res.data.code) {
				case "502":
				case "503":
				case "401":
					// TODO 登陆、请求失败等相关信息，然后跳转到授权页面
					router.push({
						name: "auth",
						params: { shop: window.location.href.split("/")[2] },
					});
					break;
			}
		}
		return res;
	},
	error => {
		//TODO 隐藏加载框
		checkLoading(2);
		if (error.response != undefined) {
			if (error.response.status === 401 || error.response.status === 403) {
				router.push({
					name: "auth",
					params: { shop: window.location.href.split("/")[2] },
				});
				throw new Error(error);
			} else if (error.response.status >= 500) {
				error.response.data.message = i18n.t("app_error");
			}
		} else {
			error.response = {
				data: {
					message: i18n.t("network_error"),
				},
			};
		}
		return Promise.reject(error);
	}
);

export default client;

let loading = 0;
function checkLoading(val = 1) {
	if (val == 2) {
		if (--loading == 0) {
			NProgress.done();
		}
	} else {
		if (loading++ == 0) {
			NProgress.inc();
		}
	}
}
